import { Link } from 'react-router-dom'

import { ROUTES } from '@/constants'
import { usePageTitle } from '@/hooks/usePageTitle'

/** Catch-all for unknown routes — web.config rewrites everything here. */
function NotFound() {
  usePageTitle('Page not found')

  return (
    <div className="willfade">
      <div className="pagehead">
        <div>
          <h1>Page not found</h1>
          <p className="pagehead__sub">
            That address doesn&apos;t match any screen.{' '}
            <Link to={ROUTES.DELIVERIES}>Back to Deliveries</Link>.
          </p>
        </div>
      </div>
    </div>
  )
}

export default NotFound
